/**
 * Deploy-time feature visibility. Build-time env vars, read through
 * functions so tests can flip them per case.
 */

/**
 * Billing visibility flag (ADR-055). Off by default: environments where
 * billing has not launched register neither the Billing route nor its
 * nav entry, so a half-configured feature is never reachable. This is
 * independent of whether tenant-service has billing configured — the
 * page's 503 handling covers that drift.
 */
export function isBillingEnabled(): boolean {
  return import.meta.env.VITE_BILLING_ENABLED === "true";
}

/**
 * Alerting visibility flag. Off by default: environments where alerting has
 * not launched register neither its routes nor its nav group. Where it is
 * on, tenant-service still decides per workspace, and the alerting pages
 * explain a workspace it has not enabled.
 */
export function isAlertingEnabled(): boolean {
  return import.meta.env.VITE_ALERTING_ENABLED === "true";
}
